/*
 * OB TIE DYE | SOCAL EVENT GUIDE LANDING LAYER (Oct 4 2026)
 * ------------------------------------------------------------
 * Adds the "discovery" layer (hub, region and category landing pages) on top of the
 * existing guide. ob-guide-v3.js is untouched and still renders the full database below.
 *
 * - Reads the same window.OB_GUIDE_ITEMS the guide uses, once. No second dataset.
 * - Each landing page is a page template (templates/page.events-*.json) that sets the
 *   section settings: region, preset filters, headline, intro and which modules to show.
 * - Presets reach the guide through its own URL params (set by the inline script in
 *   sections/ob-guide-landing.liquid before the guide boots).
 * - Buttons here drive the guide through its own controls (radio/checkbox change events),
 *   the same way a visitor's click would, so the guide's logic stays the single source of truth.
 */
(function(){
  'use strict';
  var ROOT=document.getElementById('obg'),CFG_EL=document.getElementById('oblCfg');
  if(!ROOT||!CFG_EL||ROOT.__obl)return;ROOT.__obl=true;
  var CFG={};try{CFG=JSON.parse(CFG_EL.textContent)||{}}catch(_){}
  var DAY=864e5,NOW=Date.now();
  var CDN='https://cdn.shopify.com/s/files/1/0928/5068/4179/files/';
  /* same photos as ob-guide-v3.js PHOTO (category fallbacks) */
  var PHOTO={
    farmers:'ob-tie-dye-san-diego-events-farmers-market.webp?v=1789844996',
    concert:'ob-tie-dye-san-diego-events-live-music-concert-crowd.webp?v=1789672481',
    foodWine:'ob-tie-dye-san-diego-events-food-and-wine.webp?v=1789839840',
    space:'ob-tie-dye-san-diego-events-space-night-sky-celestial-moon.webp?v=1789840136',
    art:'ob-tie-dye-san-diego-events-art.webp?v=1789840767',
    diy:'ob-tie-dye-san-diego-events-diy-workshop.jpg?v=1790444890',
    oktoberfest:'ob-tie-dye-san-diego-events-oktoberfest.webp?v=1789844762',
    yoga:'ob-tie-dye-san-diego-events-yoga.webp?v=1789920684',
    wildlife:'ob-tie-dye-san-diego-events-wildlife-birding.webp?v=1789920757',
    festival:'ob-tie-dye-socal-events-festival.webp?v=1789919350',
    film:'ob-tie-dye-san-diego-event-guide-film-movies.webp?v=1789928095',
    karaoke:'ob-tie-dye-san-diego-event-guide-karaoke.webp?v=1790010133',
    trivia:'ob-tie-dye-san-diego-events-trivia.webp?v=1789920808',
    fitness:'ob-tie-dye-socal-events-fitness.webp?v=1789919363',
    market:'ob-tie-dye-socal-events-market.webp?v=1789919368',
    run:'ob-tie-dye-san-diego-event-guide-run-club.webp?v=1789928637',
    happy:'ob-tie-dye-san-diego-events-happy-hour-sunset-drink.webp?v=1789674281',
    dog:'ob-tie-dye-hand-dyed-dog-hoodie-pink-sophie.jpg?v=1770050844',
    comedy:'ob-tie-dye-san-diego-events-comedy-show.webp?v=1789673768',
    booth:'ob-tie-dye-vending-customer-shopping.webp?v=1789665530',
    surf:'ob-tie-dye-san-diego-events-surf.webp?v=1789841638'
  };
  function photo(k,w){return PHOTO[k]?CDN+PHOTO[k]+'&width='+(w||600):''}
  /* category groups, same keys as the guide's ?categories= */
  var GROUP={arts:['art','diy','film','theater'],foodwine:['food','happy'],outdoors:['active','nature'],markets:['market','fest']};
  var REG={
    'San Diego':'sd','North County':'sd','Orange County':'oc','Los Angeles / Long Beach':'la','Inland / Desert':'ie','Santa Barbara / Central Coast':'sb','Las Vegas':'lv','Charlotte':'clt','Twin Cities':'msp','Denver':'den','Honolulu':'hnl','Washington DC':'dc','Salt Lake City':'slc','Portland':'pdx','Phoenix':'phx','Tempe':'tem','Tokyo':'tyo','Los Angeles':'la','Palm Springs + Joshua Tree':'ps','Inland Empire':'iem'
  };
  /* landing region key -> guide regions it covers */
  var AREA={sd:['San Diego','North County'],oc:['Orange County'],la:['Los Angeles / Long Beach','Los Angeles'],ie:['Inland / Desert'],ps:['Palm Springs + Joshua Tree'],iem:['Inland Empire'],lv:['Las Vegas'],clt:['Charlotte'],msp:['Twin Cities'],den:['Denver'],hnl:['Honolulu'],dc:['Washington DC'],slc:['Salt Lake City'],pdx:['Portland'],phx:['Phoenix'],tem:['Tempe'],tyo:['Tokyo']};
  /* Oct 16 2026: destination area keys -> their one place */
  var DEST_AREA={lv:'Las Vegas',clt:'Charlotte',msp:'Twin Cities',den:'Denver',hnl:'Honolulu',dc:'Washington DC',slc:'Salt Lake City',pdx:'Portland',phx:'Phoenix',tem:'Tempe',tyo:'Tokyo',ps:'Palm Springs + Joshua Tree',iem:'Inland Empire'};

  function norm(s){return String(s||'').toLowerCase().replace(/[’‘]/g,"'").replace(/\s+/g,' ').trim()}
  function slug(s){return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  /* same mapping as regionOf() in ob-guide-v3.js, minus the map-coordinate fallback */
  function regionOf(r){
    /* Oct 20 2026: SoCal destination pages hand over events already named by destination */
    var raw=String(r||'').trim();if(raw==='Los Angeles'||raw==='Palm Springs + Joshua Tree'||raw==='Inland Empire')return raw;
    var e=norm(r);
    if(/^(san diego|central san diego|east county|south bay|south county)$/.test(e))return'San Diego';
    if(e==='north county')return'North County';
    if(/^(south orange county|south oc|orange county)$/.test(e))return'Orange County';
    if(/^(los angeles|los angeles long beach|los angeles \/ long beach)$/.test(e))return'Los Angeles / Long Beach';
    if(/^(inland empire|inland \/ desert|palm desert \/ coachella valley|coachella valley|palm springs)$/.test(e))return'Inland / Desert';
    if(/santa barbara/.test(e))return'Santa Barbara / Central Coast';
    if(/^(las vegas|vegas|henderson|north las vegas|summerlin)$/.test(e))return'Las Vegas';
    if(/^(charlotte|charlotte nc|charlotte, nc|clt)$/.test(e))return'Charlotte';
    if(/^(twin cities|minneapolis|st\.? paul|saint paul|minneapolis \/ st\.? paul|minneapolis-st\.? paul|msp)$/.test(e))return'Twin Cities';
    if(/^(denver|denver, co|denver co|den|denver metro)$/.test(e))return'Denver';
    if(/^(honolulu|honolulu, hi|oahu|hnl)$/.test(e))return'Honolulu';
    if(/^(washington dc|washington, dc|washington d\.?c\.?|dc|d\.c\.)$/.test(e))return'Washington DC';
    if(/^(salt lake city|salt lake|slc|salt lake city, ut)$/.test(e))return'Salt Lake City';
    if(/^(portland|portland, or|pdx|portland oregon)$/.test(e))return'Portland';
    if(/^(tempe|tempe, az)$/.test(e))return'Tempe';
    if(/^(phoenix|phoenix, az|phx|arizona|phoenix metro|valley of the sun)$/.test(e))return'Phoenix';
    if(/^(tokyo|tokyo, japan|tyo|japan)$/.test(e))return'Tokyo';
    return'San Diego';
  }
  function hasTag(tags,rx){for(var i=0;i<tags.length;i++)if(rx.test(String(tags[i])))return true;return false}
  function catsOf(i,t,tags){
    var c=i.cat||'',mf=hasTag(tags,/^\s*music festival\s*$/i),o={};
    if(c==='Concert'||mf)o.music=1;
    if(c==='Festival'||mf)o.fest=1;
    if(c==='Market')o.market=1;
    if(c==='Art Market'){o.art=1;if(/\b(market|fair|faire|bazaar)\b/.test(t))o.market=1}
    if(c==='Food + Drink'||/\bfood\s+(?:and\s+|\+\s*|&\s*)?wine\b|\btaste of\b|\bwine tasting\b|\bwine festival\b/.test(t))o.food=1;
    if(c==='Happy Hour')o.happy=1;
    if(c==='Comedy')o.comedy=1;
    if(c==='Film')o.film=1;
    if(c==='Theater + Performing Arts')o.theater=1;
    if(c==='DIY + Workshops')o.diy=1;
    if(c==='Trivia'||c==='Karaoke'||/\bbingo\b|game night/.test(t))o.games=1;
    if(c==='Fitness + Outdoors')o.active=1;
    if(c==='Wildlife'||c==='Space + Stargazing')o.nature=1;
    if(c==='Sports')o.sports=1;
    if(hasTag(tags,/^\s*dog[\s-]*events?\s*$/i))o.dogevent=1;
    return o;
  }
  function photoKey(o){
    var t=o.t,c=o.cat;
    if(o.dogEvent)return'dog';
    if(o.here)return'booth';
    if(c==='DIY + Workshops')return'diy';
    if(/\b(run club|running club|fun run|5k|10k|half marathon|marathon)\b/.test(t))return'run';
    if(/farmers? market/.test(t))return'farmers';
    if(/\b(?:oktober|october)\s*fest\b|\bcraftober/.test(t))return'oktoberfest';
    if(c==='Food + Drink')return'foodWine';
    if(c==='Space + Stargazing')return'space';
    if(/\byoga\b/.test(t))return'yoga';
    if(c==='Wildlife')return'wildlife';
    if(c==='Film')return'film';
    if(c==='Art Market')return'art';
    if(c==='Karaoke')return'karaoke';
    if(c==='Trivia')return'trivia';
    if(c==='Fitness + Outdoors')return'fitness';
    if(c==='Market')return'market';
    if(c==='Festival')return'festival';
    if(c==='Concert')return'concert';
    if(c==='Happy Hour')return'happy';
    if(c==='Comedy')return'comedy';
    /* Oct 6 2026: categories with no photo of their own used to leave an empty photo box on the card */
    if(c==='Theater + Performing Arts')return'concert';
    return'festival';
  }

  /* ---------- Pacific dates, cached per hour so 19k items cost a few hundred lookups ---------- */
  var FMT=new Intl.DateTimeFormat('en-US',{timeZone:window.OB_GUIDE_TZ||'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23',weekday:'short'});
  var HC={};
  function parts(ms){
    var h=Math.floor(ms/36e5),c=HC[h];
    if(!c){var p={};FMT.formatToParts(new Date(h*36e5)).forEach(function(x){p[x.type]=x.value});c=HC[h]={day:p.year+'-'+p.month+'-'+p.day,hour:+p.hour,wd:p.weekday}}
    return c;
  }
  function minOf(ms){return new Date(ms).getUTCMinutes()}
  function addDays(k,n){var a=k.split('-').map(Number),d=new Date(Date.UTC(a[0],a[1]-1,a[2]+n,12));return d.toISOString().slice(0,10)}
  function dow(k){var a=k.split('-').map(Number);return new Date(Date.UTC(a[0],a[1]-1,a[2],12)).getUTCDay()}
  var TODAY=parts(NOW).day;
  function weekend(t,next){var d=dow(t),fri=d===6?addDays(t,-1):d===0?addDays(t,-2):addDays(t,(5-d+7)%7);if(next)fri=addDays(fri,7);return[fri,addDays(fri,2)]}
  var MON=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function dayLabel(k){var a=k.split('-');return['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][dow(k)]+', '+MON[+a[1]-1]+' '+(+a[2])}
  function timeLabel(o){
    if(o.allDay)return'';
    var h=parts(o.s).hour,m=minOf(o.s),ap=h>=12?'pm':'am',h12=h%12||12;
    return h12+(m?':'+(m<10?'0':'')+m:'')+ap;
  }

  /* ---------- one pass over the shared list ---------- */
  var RAW=window.OB_GUIDE_ITEMS||[],ITEMS=[],COUNT={sd:0,oc:0,la:0,ie:0,ps:0,iem:0,lv:0,clt:0,msp:0,den:0,hnl:0,dc:0,slc:0,pdx:0,phx:0,tem:0,tyo:0,all:0},SEEN={},TITLE_N={},SHOWN={};
  var HORIZON=NOW+90*DAY;
  function prep(){
    if(window.OB_GUIDE_TAG_WEEKLY){try{window.OB_GUIDE_TAG_WEEKLY(RAW)}catch(_){}}
    for(var n=0;n<RAW.length;n++){
      var i=RAW[n];if(!i||!i.title||!i.start)continue;
      var s=Date.parse(i.start);if(isNaN(s))continue;
      var e=i.end?Date.parse(i.end):s+6*36e5;if(isNaN(e))e=s+6*36e5;
      if(e<NOW)continue;
      var region=regionOf(i.region),rk=REG[region]||'sd',t=norm(i.title);
      var dk=t+'|'+Math.floor(s/36e5)+'|'+norm(i.place);
      if(SEEN[dk])continue;SEEN[dk]=1;
      COUNT.all++;COUNT[rk]=(COUNT[rk]||0)+1;
      TITLE_N[t]=(TITLE_N[t]||0)+1;
      if(s>HORIZON)continue;
      var tags=Array.isArray(i.tags)?i.tags:(i.tags?String(i.tags).split(','):[]);
      var m=String(i.desc||'').match(/(?:^|\n)\s*image(?: url)?\s*:\s*(https?:\/\/[^\s<>]+)/i);
      var own=i.image||(m?m[1]:'')||(window.OB_GUIDE_EVENT_IMAGES||{})[t]||'';
      var o={raw:i,tg:tags.map(function(x){return norm(x)}),t:t,title:String(i.title),cat:i.cat||'',place:i.place||'',hood:i.hood||'',region:region,rk:rk,
        s:s,e:e,allDay:!!i.all_day,url:i.url||'',own:own,
        here:i.here===true||i.here==='TRUE'||/ob tie dye|obtiedye/.test(t),
        pick:i.starred===true||i.starred==='TRUE',
        dog:hasTag(tags,/^\s*dog[\s-]*friendly\s*$/i),
        kids:hasTag(tags,/^\s*(family|families|kids|family[\s-]*friendly|kid[\s-]*friendly|all[\s-]*ages)\s*$/i),
        free:hasTag(tags,/^\s*free\s*$/i)||/\bfree\b/.test(t)};
      o.cats=catsOf(i,t,tags);o.dogEvent=!!o.cats.dogevent;
      o.wk=!!i.weekly&&!o.pick&&!o.here;
      var pr=String(i.priority||'').trim().toLowerCase();
      o.low=!o.pick&&!o.here&&(pr==='low'||hasTag(tags,/^\s*low(\s+priority)?\s*$/i));
      o.radar=!o.pick&&!o.low&&(pr==='radar'||hasTag(tags,/^\s*(on\s+our\s+)?radar\s*$/i));
      var a=parts(s);o.sd=a.day;o.ed=parts(Math.max(s,e-1000)).day;if(o.ed<o.sd)o.ed=o.sd;
      ITEMS.push(o);
    }
  }

  /* ---------- module filters ---------- */
  function leaves(list){var out=[];(list||[]).forEach(function(k){(GROUP[k]||[k]).forEach(function(x){if(out.indexOf(x)<0)out.push(x)})});return out}
  function inArea(o,areas){if(!areas||!areas.length)return true;for(var i=0;i<areas.length;i++)if((AREA[areas[i]]||[]).indexOf(o.region)>-1)return true;return false}
  function whenOk(o,w){
    var t=TODAY;
    switch(w){
      case'today':return o.sd<=t&&o.ed>=t;
      case'tonight':return o.sd<=t&&o.ed>=t&&!o.allDay&&(o.sd<t||parts(o.s).hour>=16||parts(o.e).hour>=17);
      case'weekend':var r=weekend(t);return o.ed>=r[0]&&o.sd<=r[1];
      case'nextweekend':var r2=weekend(t,true);return o.ed>=r2[0]&&o.sd<=r2[1];
      case'week':return o.ed>=t&&o.sd<addDays(t,7);
      case'month':return o.ed>=t&&o.sd<addDays(t,31);
      default:return o.ed>=t;
    }
  }
  function select(spec){
    var cats=leaves(spec.cats),excl=leaves(spec.exclude),areas=spec.areas||[],out=[],byTitle={},venue={};
    var weekly=spec.allowWeekly||cats.some(function(c){return c==='happy'||c==='games'});
    for(var n=0;n<ITEMS.length;n++){
      var o=ITEMS[n];
      if(!inArea(o,areas))continue;
      if(o.low)continue;
      if(spec.picks&&!o.pick)continue;
      if(spec.radar&&!o.radar)continue;
      if(spec.dog&&!o.dog)continue;
      if(spec.free&&!o.free)continue;
      if(spec.kids&&!o.kids)continue;
      if(spec.hood&&norm(o.hood)!==norm(spec.hood))continue;
      if(spec.tag&&o.tg.indexOf(spec.tag)<0)continue;
      if(spec.skip&&spec.skip[o.t])continue;
      if(cats.length&&!cats.some(function(c){return o.cats[c]}))continue;
      if(excl.length&&excl.some(function(c){return o.cats[c]}))continue;
      if(!weekly&&(o.cats.happy||o.cats.games||o.wk))continue;
      if(!whenOk(o,spec.when))continue;
      var prev=byTitle[o.t];
      if(prev){if(o.s<prev.s&&o.s>=NOW-6*36e5){byTitle[o.t]=o}continue}
      byTitle[o.t]=o;
    }
    for(var k in byTitle)out.push(byTitle[k]);
    function score(o){
      var sc=0,span=(o.e-o.s)/DAY,rec=(TITLE_N[o.t]||0)>3;
      if(o.pick)sc+=100;if(o.here)sc+=50;if(o.radar)sc+=40;if(o.own)sc+=30;
      if(rec&&!weekly)sc-=60;if(span>3)sc-=25;
      return sc;
    }
    if(spec.sort==='featured')out.sort(function(a,b){return score(b)-score(a)||a.s-b.s});
    else out.sort(function(a,b){return Math.max(a.s,NOW)-Math.max(b.s,NOW)||(b.pick-a.pick)});
    var res=[];
    for(var j=0;j<out.length&&res.length<spec.limit;j++){
      var v=norm(out[j].place);if(!spec.tag&&v&&(venue[v]||0)>=2)continue;venue[v]=(venue[v]||0)+1;res.push(out[j]);
    }
    return res;
  }

  /* ---------- markup ---------- */
  function img(o,w){
    if(o.own)return /cdn\.shopify\.com|\/cdn\/shop\//.test(o.own)?o.own+(o.own.indexOf('?')>-1?'&':'?')+'width='+w:o.own;
    return photo(photoKey(o),w);
  }
  function whenText(o){
    var d=o.sd<TODAY?(o.ed>TODAY?'Now thru '+dayLabel(o.ed).slice(5):'Today'):o.sd===TODAY?'Today':o.sd===addDays(TODAY,1)?'Tomorrow':dayLabel(o.sd);
    var tm=o.sd<TODAY?'':timeLabel(o);return d+(tm?' · '+tm:'');
  }
  function guideLink(o){
    var u=new URL(location.origin+location.pathname);keepView(u);
    u.searchParams.set('q',String(o.title).split(' @ ')[0].replace(/[^\p{L}\p{N}'&+\s]+/gu,' ').replace(/\s+/g,' ').trim());
    var d=o.sd<TODAY?TODAY:o.sd;u.searchParams.set('from',d);u.searchParams.set('to',d);u.hash='obgAll';return u.toString();
  }
  function href(o){return o.url||guideLink(o)}
  function ext(o){return o.url?' target="_blank" rel="noopener"':''}
  function badges(o,showRegion){
    var b='';
    if(o.pick)b+='<span class="obl-b obl-b-pick">&#9733; OB Pick</span>';
    if(o.here)b+='<span class="obl-b obl-b-here">We&#39;re vending</span>';
    if(showRegion&&o.rk!=='sd')b+='<span class="obl-b">'+esc(o.region.split(' / ')[0])+'</span>';
    if(o.free)b+='<span class="obl-b obl-b-free">Free</span>';
    return b?'<span class="obl-badges">'+b+'</span>':'';
  }
  function where(o){return esc(o.place)+(o.hood&&norm(o.hood)!==norm(o.place)?' · '+esc(o.hood):'')}
  function card(o,showRegion){
    var src=img(o,600),fb=o.own?photo(photoKey(o),600):'';
    /* Oct 6 2026: an event's own image (sheet Image URL) falls back to the category photo if it fails to load */
    return '<a class="obl-card'+(o.pick?' is-pick':'')+'" href="'+esc(href(o))+'"'+ext(o)+'>'+
      '<span class="obl-ph">'+(src?'<img src="'+esc(src)+'"'+(fb&&fb!==src?' data-fb="'+esc(fb)+'"':'')+' alt="" loading="lazy" decoding="async" width="600" height="400">':'')+'</span>'+
      '<span class="obl-cb"><span class="obl-when">'+esc(whenText(o))+'</span><strong class="obl-ttl">'+esc(o.title)+'</strong><span class="obl-where">'+where(o)+'</span>'+badges(o,showRegion)+'</span></a>';
  }
  function row(o,showRegion){
    var dk=o.sd<TODAY?TODAY:o.sd,a=dk.split('-');
    return '<a class="obl-row" href="'+esc(href(o))+'"'+ext(o)+'><span class="obl-date"><b>'+['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][dow(dk)]+'</b><strong>'+MON[+a[1]-1]+' '+(+a[2])+'</strong></span>'+
      '<span class="obl-rb"><strong class="obl-ttl">'+esc(o.title)+'</strong><span class="obl-where">'+(timeLabel(o)&&o.sd>=TODAY?esc(timeLabel(o))+' · ':'')+where(o)+'</span>'+badges(o,showRegion)+'</span></a>';
  }
  function list(s){return String(s||'').split(',').map(function(x){return x.trim()}).filter(Boolean)}

  /* ---------- modules ---------- */
  /* Oct 6 2026: OB Tie Dye Picks run soonest first (events already underway count as now) */
  function renderModules(){
    var showRegion=!(CFG.areas&&CFG.areas.length===1);
    Array.prototype.forEach.call(ROOT.querySelectorAll('[data-obl-mod]'),function(sec){
      var m={};try{m=JSON.parse(sec.getAttribute('data-obl-mod'))||{}}catch(_){}
      var body=sec.querySelector('.obl-body');if(!body)return;
      var solo=!!m.solo,spec={cats:list(m.cats),exclude:list(m.exclude),areas:m.areas?list(m.areas):(CFG.areas||[]),picks:!!m.picks,radar:!!m.radar,dog:!!(m.dog||(!solo&&CFG.dog)),free:!!(m.free||(!solo&&CFG.free)),kids:!!m.kids,
        tag:m.tag?norm(m.tag):'',when:m.when||'any',limit:+m.limit||6,sort:m.sort||(m.style==='list'||sec.classList.contains('obl-picks')?'date':'featured'),allowWeekly:!!m.weekly};
      if(!solo&&!spec.cats.length&&CFG.cats&&CFG.cats.length)spec.cats=CFG.cats;
      /* an event already shown higher up the page is skipped, unless that would leave this module thin */
      spec.skip=SHOWN;var res=select(spec);
      if(res.length<Math.min(spec.limit,3)){spec.skip=null;res=select(spec);spec.skip=SHOWN}
      if(res.length<(+m.min||1)){
        if(m.fallback_when&&m.fallback_when!=='none'&&m.when!==m.fallback_when){spec.when=m.fallback_when;res=select(spec);var sub=sec.querySelector('[data-obl-fb]');if(res.length&&sub)sub.textContent=sub.getAttribute('data-obl-fb')}
      }
      if(!res.length){if(m.empty){body.innerHTML='<p class="obl-empty">'+esc(m.empty)+'</p>'}else sec.hidden=true;return}
      sec.hidden=false;
      res.forEach(function(o){SHOWN[o.t]=1});
      var sr=m.areas?list(m.areas).length!==1:showRegion;
      body.innerHTML=m.style==='list'?'<div class="obl-rows">'+res.map(function(o){return row(o,sr)}).join('')+'</div>':'<div class="obl-car"><button type="button" class="obl-arr obl-prev" data-obl-arr="-1" aria-label="Previous" disabled>&#8249;</button><div class="obl-cards">'+res.map(function(o){return card(o,sr)}).join('')+'</div><button type="button" class="obl-arr obl-next" data-obl-arr="1" aria-label="Next">&#8250;</button></div>';
      carousel(body.querySelector('.obl-car'));
    });
  }
  /* Oct 5 2026: card modules are one swipeable row (arrows on desktop) */
  function carousel(c){
    if(!c)return;var sc=c.querySelector('.obl-cards'),pv=c.querySelector('.obl-prev'),nx=c.querySelector('.obl-next');
    function upd(){var max=sc.scrollWidth-sc.clientWidth-4;pv.disabled=sc.scrollLeft<=4;nx.disabled=sc.scrollLeft>=max;c.classList.toggle('is-static',max<=0)}
    sc.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd,{passive:true});
    c.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('[data-obl-arr]');if(!b)return;e.preventDefault();sc.scrollBy({left:(+b.getAttribute('data-obl-arr'))*sc.clientWidth*0.9,behavior:'smooth'})});
    upd();setTimeout(upd,300);
  }
  function renderCounts(){
    Array.prototype.forEach.call(ROOT.querySelectorAll('[data-obl-count]'),function(el){
      var k=el.getAttribute('data-obl-count'),n=COUNT[k]||0;
      el.textContent=n?n.toLocaleString()+' upcoming':'Coming soon';
    });
  }
  function renderHoods(){
    Array.prototype.forEach.call(ROOT.querySelectorAll('[data-obl-hoods]'),function(sec){
      var areas=CFG.areas||[],max=+sec.getAttribute('data-obl-hoods')||12,c={},reg={},seen={};
      var horizon=addDays(TODAY,30);
      ITEMS.forEach(function(o){
        if(!o.hood||!inArea(o,areas)||o.sd>horizon)return;
        var k=o.hood+'|'+o.t+'|'+o.sd;if(seen[k])return;seen[k]=1;
        c[o.hood]=(c[o.hood]||0)+1;reg[o.hood]=o.region;
      });
      var top=Object.keys(c).filter(function(h){return c[h]>=3}).sort(function(a,b){return c[b]-c[a]}).slice(0,max);
      var body=sec.querySelector('.obl-body');
      if(!top.length||!body){sec.hidden=true;return}
      body.innerHTML='<div class="obl-hoods">'+top.map(function(h){
        var u=new URL(location.origin+location.pathname);keepView(u);u.searchParams.set('region',slug(reg[h]));u.searchParams.set('neighborhood',slug(h));u.hash='obgAll';
        return '<a class="obl-hood" href="'+esc(u.toString())+'"><strong>'+esc(h)+'</strong><span>'+c[h].toLocaleString()+' this month</span></a>';
      }).join('')+'</div>';
      sec.hidden=false;
    });
  }
  function renderPhotos(){
    Array.prototype.forEach.call(ROOT.querySelectorAll('[data-obl-photo]'),function(el){
      var u=photo(el.getAttribute('data-obl-photo'),500);
      if(u&&!el.querySelector('img'))el.insertAdjacentHTML('afterbegin','<img src="'+esc(u)+'" alt="" loading="lazy" decoding="async" width="500" height="375">');
    });
  }

  /* ---------- driving the guide through its own controls ---------- */
  function fire(el){if(!el)return;el.dispatchEvent(new Event('change',{bubbles:true}))}
  function setRadio(name,val){var el=ROOT.querySelector('input[name="'+name+'"][value="'+val+'"]');if(el&&!el.checked){el.checked=true;fire(el)}return el}
  function guideState(){try{return window.OB_GUIDE_V3&&window.OB_GUIDE_V3.state()}catch(_){return null}}
  /* Height of the theme's sticky header (Oct 5 2026 fix: the old lookup found an empty placeholder div and returned 0,
     so jumps landed with the heading hidden under the header). Measures whatever sticks to the top of the screen. */
  function headerOffset(){
    var off=0;
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-header-group, #header-group > *, header'),function(e){
      var s=getComputedStyle(e);if(s.position!=='sticky'&&s.position!=='fixed')return;
      var h=e.offsetHeight+(parseFloat(s.top)||0);if(h>off&&h<window.innerHeight/2)off=h;
    });
    return Math.max(0,Math.round(off));
  }
  function setHeaderVar(){try{document.documentElement.style.setProperty('--obl-hdr',headerOffset()+'px')}catch(_){}}
  function toAll(){var a=document.getElementById('obgAll');if(!a)return;var off=headerOffset();window.scrollTo({top:a.getBoundingClientRect().top+window.scrollY-off-8,behavior:'smooth'})}
  function keepView(u){try{var p=new URL(location.href).searchParams,v=p.get('view');if(v)u.searchParams.set('view',v)}catch(_){}}

  function bindDates(){
    ROOT.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('[data-obl-when]');if(!b)return;
      var w=b.getAttribute('data-obl-when');
      if(w==='pick'){e.preventDefault();var d=ROOT.querySelector('.obg-toolbar [data-open="date"]');toAll();if(d&&getComputedStyle(d.parentNode).display!=='none')d.click();else{var g=ROOT.querySelector('.obg-group[data-group="date"]');if(g&&!g.classList.contains('is-open')){var h=g.querySelector('.obg-group-head');h&&h.click()}var f=document.getElementById('obgFrom');setRadio('obg-when','custom');setTimeout(function(){f&&f.focus()},400)}return}
      if(w==='nextweekend')return;/* plain link, see setNextWeekend() */
      e.preventDefault();
      setRadio('obg-when',w);
      Array.prototype.forEach.call(ROOT.querySelectorAll('[data-obl-when]'),function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});
      toAll();
    });
  }
  function setNextWeekend(){
    var r=weekend(TODAY,true);
    Array.prototype.forEach.call(ROOT.querySelectorAll('[data-obl-when="nextweekend"]'),function(a){
      var u=new URL(location.origin+location.pathname);keepView(u);u.searchParams.set('from',r[0]);u.searchParams.set('to',r[1]);u.hash='obgAll';a.href=u.toString();
    });
  }
  /* Same-page links written in Liquid lose ?view= in theme previews. Add it back. */
  function fixPreviewLinks(){
    var p;try{p=new URL(location.href).searchParams}catch(_){return}
    var role=window.Shopify&&Shopify.theme&&Shopify.theme.role,v=p.get('view');
    Array.prototype.forEach.call(document.querySelectorAll('#obg a[href^="/pages/events"]'),function(a){
      var u=new URL(a.getAttribute('href'),location.origin);
      if(u.pathname===location.pathname&&v&&!u.searchParams.get('view'))u.searchParams.set('view',v);
      /* before the landing pages exist, previews open them as alternate templates of /pages/events */
      else if(role&&role!=='main'&&u.pathname!=='/pages/events'&&/^\/pages\/events-/.test(u.pathname)){u.searchParams.set('view',u.pathname.slice(7));u.pathname='/pages/events'}
      a.setAttribute('href',u.pathname+u.search+u.hash);
    });
  }

  /* Region pages: a search looks across all of SoCal (the guide already does this on the
     default San Diego view; a preset region would otherwise keep it boxed in). Clearing the
     search puts the page's own region back. A visitor who picks an area mid-search keeps it. */
  function bindSearch(){
    var si=document.getElementById('obgSearch');if(!si)return;
    var home=CFG.region||'',switched=false,userPicked=false,timer;
    function searching(on){ROOT.classList.toggle('obl-searching',!!on)}
    searching(!!si.value.trim());
    ROOT.addEventListener('change',function(e){if(e.isTrusted&&e.target.name==='obg-region')userPicked=true},true);
    ROOT.addEventListener('click',function(e){if(e.isTrusted&&e.target.closest&&e.target.closest('[data-rchip]'))userPicked=true},true);
    function check(){
      var st=guideState();if(!st)return;
      if(st.q){
        if(home&&!switched&&!userPicked&&st.region===home&&!st.hoods.length){switched=true;setRadio('obg-region','all')}
      }else{
        if(home&&switched&&!userPicked&&st.region==='all')setRadio('obg-region',home);
        switched=false;userPicked=false;
      }
    }
    ROOT.addEventListener('input',function(e){if(e.target!==si)return;searching(!!si.value.trim());clearTimeout(timer);timer=setTimeout(check,450)});
    ROOT.addEventListener('click',function(e){if(e.target.closest&&(e.target.closest('.obg-search-clear')||e.target.closest('[data-remove="q"]'))){searching(false);setTimeout(check,60)}});
    si.addEventListener('keydown',function(e){if(e.key==='Enter'){clearTimeout(timer);setTimeout(check,30)}});
    if(home){var st=guideState();if(st&&st.q)switched=st.region==='all'}
  }
  /* "Reset filters" goes back to this page's starting point, not the guide's San Diego default */
  function bindReset(){
    if(!CFG.region&&!(CFG.cats&&CFG.cats.length)&&!CFG.dog&&!CFG.free&&!CFG.weekly)return;
    ROOT.addEventListener('click',function(e){
      if(!(e.target.closest&&e.target.closest('[data-reset]')))return;
      setTimeout(function(){
        if(CFG.region)setRadio('obg-region',CFG.region);
        (CFG.presetCats||[]).forEach(function(k){
          var el=ROOT.querySelector('input[name="obg-grp"][value="'+k+'"]')||ROOT.querySelector('input[name="obg-cat"][value="'+k+'"]');
          if(el&&!el.checked){el.checked=true;fire(el)}
        });
        ['dog','free'].forEach(function(k){if(CFG[k]){var el=ROOT.querySelector('input[name="obg-good"][value="'+k+'"]');if(el&&!el.checked){el.checked=true;fire(el)}}});
        /* the weekly page's starting point (weekly stuff only) can't be rebuilt from the guide's own buttons, so reload it clean */
        if(CFG.weekly){var u=new URL(location.origin+location.pathname);keepView(u);location.href=u.toString()}
      },0);
    });
  }

  /* ---------- remembered area + Near me (Oct 5 2026) ----------
     Shopify only knows a visitor's country, so nothing is detected automatically. The guide remembers the last
     area someone picked (on this device) and the hub opens there; "Near me" asks for location only when tapped. */
  var AREA_KEY='obGuideArea',GUIDE_REGIONS=['San Diego','North County','Orange County','Los Angeles / Long Beach','Inland / Desert'];
  var CENTERS={'San Diego':[32.76,-117.16],'North County':[33.12,-117.27],'Orange County':[33.66,-117.83],'Los Angeles / Long Beach':[33.98,-118.25],'Inland / Desert':[33.8,-116.6]};
  function getArea(){try{var a=localStorage.getItem(AREA_KEY);return GUIDE_REGIONS.indexOf(a)>-1?a:''}catch(_){return''}}
  function saveArea(a){if(GUIDE_REGIONS.indexOf(a)<0)return;try{localStorage.setItem(AREA_KEY,a)}catch(_){}}
  function areaOfPage(){if(CFG.region)return CFG.region;if(CFG.areas&&CFG.areas.length===1&&CFG.areas[0]==='sd')return'San Diego';return''}
  function urlHasArea(){try{var p=new URL(location.href).searchParams;return p.has('region')||p.has('area')||p.has('neighborhood')||p.has('q')||p.has('search')}catch(_){return true}}
  function nearest(lat,lng){var best='',bd=1e9;Object.keys(CENTERS).forEach(function(k){var c=CENTERS[k],d=Math.pow(c[0]-lat,2)+Math.pow((c[1]-lng)*0.84,2);if(d<bd){bd=d;best=k}});return bd<1.2?best:''}
  function bindArea(){
    ROOT.addEventListener('change',function(e){if(e.isTrusted&&(e.target.name==='obg-region'||e.target.id==='obgHeroRegion'))saveArea(e.target.value)},true);
    var mine=areaOfPage();if(mine)saveArea(mine);
    /* the hub (and the weekly page) open on the remembered area unless the link already chose one */
    if(!CFG.region&&!(CFG.areas&&CFG.areas.length)&&!urlHasArea()){
      var a=getArea(),st=guideState();
      if(a&&st&&st.region!==a)setRadio('obg-region',a);
    }
    ROOT.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('[data-obl-near]');if(!b)return;
      e.preventDefault();
      if(!navigator.geolocation){b.textContent='Location not available';return}
      var label=b.textContent;b.textContent='Finding you…';b.disabled=true;
      navigator.geolocation.getCurrentPosition(function(pos){
        b.disabled=false;var a=nearest(pos.coords.latitude,pos.coords.longitude);
        if(!a){b.textContent='Outside SoCal? Showing everything';setRadio('obg-region','all');toAll();return}
        b.textContent=label;saveArea(a);setRadio('obg-region',a);
        var wb=ROOT.querySelector('[data-obl-weekly]');if(wb&&wb.__setArea){wb.__setArea(a)}else toAll();
      },function(){b.disabled=false;b.textContent=label},{timeout:8000,maximumAge:6e5});
    });
  }

  /* ---------- weekly board (Happy Hours + Weekly Stuff page) ----------
     Weekly regulars for one day at a time, grouped by neighborhood. Built from the same list as everything else. */
  var WTYPES=[
    {k:'all',label:'Everything'},
    {k:'happy',label:'Happy hours',test:function(o){return o.cats.happy}},
    {k:'games',label:'Trivia + karaoke',test:function(o){return o.cats.games}},
    {k:'music',label:'Live music',test:function(o){return o.cats.music||o.cats.comedy}},
    {k:'active',label:'Run clubs + outdoors',test:function(o){return o.cats.active||o.cats.nature||o.cats.sports}},
    {k:'market',label:'Markets + food',test:function(o){return o.cats.market||o.cats.food}}
  ];
  var BOARD_AREAS=[['San Diego','San Diego'],['North County','North County'],['Orange County','Orange County'],['Los Angeles / Long Beach','LA + Long Beach'],['Inland / Desert','Inland + Desert'],['all','All of SoCal']];
  function endLabel(o){
    if(o.allDay)return'';
    var h=parts(o.e).hour,m=minOf(o.e),ap=h>=12?'pm':'am',h12=h%12||12;
    return h12+(m?':'+(m<10?'0':'')+m:'')+ap;
  }
  function span(o){
    var a=timeLabel(o),b=endLabel(o);if(!a)return'All day';if(!b||b===a)return a;
    if(a.slice(-2)===b.slice(-2))a=a.slice(0,-2);
    return a+'-'+b;
  }
  function renderWeekly(){
    Array.prototype.forEach.call(ROOT.querySelectorAll('[data-obl-weekly]'),function(sec){
      var body=sec.querySelector('.obl-body');if(!body)return;
      var days=[];for(var i=0;i<7;i++)days.push(addDays(TODAY,i));
      /* Oct 7 2026: destination pages (Las Vegas) use their own place instead of the SoCal area buttons */
      var LV=(CFG.areas&&CFG.areas.length===1&&DEST_AREA[CFG.areas[0]])||'';
      var AREAS=LV?[[LV,LV]]:BOARD_AREAS;
      var st={day:TODAY,area:LV?LV:(getArea()||areaOfPage()||'San Diego'),type:'all',open:{}};
      try{var p=new URL(location.href).searchParams,d=p.get('day');if(d){var ix=['sun','mon','tue','wed','thu','fri','sat'].indexOf(d.slice(0,3).toLowerCase());if(ix>-1)st.day=days.filter(function(k){return dow(k)===ix})[0]||st.day}}catch(_){}
      function pills(kind,items,cur){return '<div class="obl-quick obl-wk-'+kind+'" role="group">'+items.map(function(x){return '<button type="button" class="obl-pill" data-wk-'+kind+'="'+esc(x[0])+'" aria-pressed="'+(x[0]===cur?'true':'false')+'">'+esc(x[1])+'</button>'}).join('')+'</div>'}
      function dayName(k,i){return i===0?'Today':i===1?'Tomorrow':['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][dow(k)]}
      function draw(){
        var pool={},n=0,type=WTYPES.filter(function(t){return t.k===st.type})[0];
        ITEMS.forEach(function(o){
          if(o.low||!(o.wk||o.cats.happy||o.cats.games))return;
          if(o.sd!==st.day)return;
          if(st.area!=='all'&&o.region!==st.area)return;
          if(type.test&&!type.test(o))return;
          var h=o.hood||o.region.split(' / ')[0],k=o.t+'|'+norm(o.place);
          var g=pool[h]||(pool[h]={});if(g[k])return;g[k]=o;n++;
        });
        var groups=Object.keys(pool).map(function(h){var arr=Object.keys(pool[h]).map(function(k){return pool[h][k]}).sort(function(a,b){return a.s-b.s});return {h:h,list:arr}})
          .sort(function(a,b){return b.list.length-a.list.length||a.h.localeCompare(b.h)});
        var html=pills('day',days.map(function(k,i){return [k,dayName(k,i)]}),st.day)+
          (LV?'':pills('area',AREAS,st.area).replace('</div>','<button type="button" class="obl-pill obl-near" data-obl-near>Near me</button></div>'))+
          pills('type',WTYPES.map(function(t){return [t.k,t.label]}),st.type)+
          '<p class="obl-wk-count">'+(n?n.toLocaleString()+' things on '+(st.day===TODAY?'today':dayLabel(st.day))+(st.area==='all'?' across SoCal':' in '+((AREAS.filter(function(a){return a[0]===st.area})[0]||[0,st.area])[1])):'Nothing listed for that day yet. Try another day or area.')+'</p>';
        html+='<div class="obl-wk-groups">'+groups.map(function(g){
          var open=st.open[g.h],show=open?g.list:g.list.slice(0,6);
          return '<div class="obl-wk-group"><h3>'+esc(g.h)+' <span>'+g.list.length+'</span></h3><div class="obl-wk-list">'+show.map(function(o){
            var tag=o.cats.happy?'Happy hour':o.cats.games?(o.cat==='Karaoke'?'Karaoke':'Trivia'):o.cats.music?'Live music':o.cats.comedy?'Comedy':(o.cats.active||o.cats.nature)?'Outdoors':o.cats.market?'Market':o.cats.food?'Food + drink':'';
            return '<a class="obl-wk-row" href="'+esc(href(o))+'"'+ext(o)+'><span class="obl-wk-time">'+esc(span(o))+'</span><span class="obl-wk-main"><strong>'+esc(o.title)+'</strong><small>'+esc(o.place||'')+(tag?' · '+tag:'')+'</small></span></a>';
          }).join('')+'</div>'+(g.list.length>6&&!open?'<button type="button" class="obl-wk-more" data-wk-open="'+esc(g.h)+'">+ '+(g.list.length-6)+' more in '+esc(g.h)+'</button>':'')+'</div>';
        }).join('')+'</div>';
        body.innerHTML=html;
      }
      sec.__setArea=function(a){st.area=a;st.open={};draw();sec.scrollIntoView({behavior:'smooth',block:'start'})};
      sec.addEventListener('click',function(e){
        var b=e.target.closest&&e.target.closest('[data-wk-day],[data-wk-area],[data-wk-type],[data-wk-open]');if(!b)return;
        if(b.hasAttribute('data-wk-day'))st.day=b.getAttribute('data-wk-day');
        else if(b.hasAttribute('data-wk-area')){st.area=b.getAttribute('data-wk-area');saveArea(st.area);setRadio('obg-region',st.area)}
        else if(b.hasAttribute('data-wk-type'))st.type=b.getAttribute('data-wk-type');
        else{st.open[b.getAttribute('data-wk-open')]=1}
        if(!b.hasAttribute('data-wk-open'))st.open={};
        draw();
      });
      draw();sec.hidden=false;
    });
  }

  /* a card photo that fails to load swaps to its fallback once, otherwise it is removed (no broken-image icon) */
  ROOT.addEventListener('error',function(e){
    var im=e.target;if(!im||im.tagName!=='IMG'||!im.closest||!im.closest('.obl-ph'))return;
    var fb=im.getAttribute('data-fb');
    if(fb){im.removeAttribute('data-fb');im.src=fb}else{im.remove()}
  },true);
  function run(){
    var t0=performance.now();
    prep();renderCounts();renderModules();renderHoods();renderPhotos();renderWeekly();setNextWeekend();fixPreviewLinks();setHeaderVar();
    ROOT.classList.add('obl-ready');
    if(location.hash==='#obgAll')setTimeout(toAll,60);
    window.OB_GUIDE_LANDING={ms:Math.round(performance.now()-t0),items:ITEMS.length,counts:COUNT};
  }
  bindDates();bindSearch();bindReset();bindArea();setHeaderVar();window.addEventListener('resize',setHeaderVar,{passive:true});
  /* the guide paints first; the discovery modules fill in right after */
  if(window.OB_GUIDE_ITEMS&&window.OB_GUIDE_ITEMS.length)run();
  else document.addEventListener('DOMContentLoaded',run);
})();
